import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { NbApiService } from '@service/nb-api.service';

@Component({
  selector: 'audit-remark',
  templateUrl: './audit-remark.component.html',
})
export class AuditRemarkComponent implements OnInit {
  @Input() id: any;
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<boolean>();
  form: FormGroup;
  loading = false;
  title = '提交审核意见';

  constructor(
    private nbApi: NbApiService,
    protected http: _HttpClient,
    public msg: NzMessageService,
    private fb: FormBuilder,
    public notify: NzNotificationService,
  ) {
    this.form = this.fb.group({
      remark: [null, [Validators.required, Validators.maxLength(255)]],
    });
  }

  ngOnInit(): void {}

  close(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  submit(status: boolean): void {
    const remark = this.form.value.remark;
    let apiRequest: any;
    if (this.id) {
      status ? (apiRequest = this.nbApi.approvedAudit(this.id, { remark })) : (apiRequest = this.nbApi.rejectAudit(this.id, { remark }));
      apiRequest.subscribe((e: any) => {
        if (e.code === 200) {
          this.msg.success('提交成功');
          this.refresh.emit(true);
          this.close();
        }
      });
    }
  }
}
